"use strict";

require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StaticFields = void 0;
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.array.concat.js");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _components = require("./components");
var _react = _interopRequireDefault(require("react"));
var _constants = require("./constants");
var _propTypes = require("prop-types");
var _formElements = require("@evidation/form-elements");
var _lodash = _interopRequireDefault(require("lodash"));
var _removeMarkdown = _interopRequireDefault(require("remove-markdown"));
var _fieldsLegacy = require("./fieldsLegacy");
var _utils = require("./utils");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var FieldStatic = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(FieldStatic, _React$PureComponent);
  var _super = _createSuper(FieldStatic);
  function FieldStatic() {
    (0, _classCallCheck2["default"])(this, FieldStatic);
    return _super.apply(this, arguments);
  }
  (0, _createClass2["default"])(FieldStatic, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        intf = _this$props["interface"],
        label = _this$props.label,
        onClick = _this$props.onClick,
        buttonStyle = _this$props.buttonStyle,
        disabled = _this$props.disabled,
        _this$props$content = _this$props.content,
        content = _this$props$content === void 0 ? null : _this$props$content;
      var name = this.props.name;
      if (!intf && !name && !_lodash["default"].includes(_constants.allowedNoName, intf)) {
        console.warn("Field does not have a \"name\" ".concat(intf, " ").concat(name, " - assigning one."));
        name = _lodash["default"].truncate(label, {
          length: 25,
          omission: ""
        });
      }
      var _generateCommonPassed = (0, _fieldsLegacy.generateCommonPassedProps)(this.props),
        fieldName = _generateCommonPassed.fieldName;
      switch (intf) {
        case "markdown":
          return /*#__PURE__*/_react["default"].createElement(_formElements.MarkdownHtml, null, label);
        case "scrollbox":
        case "scrollboxsmall":
        case "scrollboxlarge":
          return /*#__PURE__*/_react["default"].createElement(_components.Scrollbox, {
            size: intf === "scrollboxlarge" ? "large" : "small",
            label: label
          });
        case "label":
          return /*#__PURE__*/_react["default"].createElement("label", {
            dangerouslySetInnerHTML: {
              __html: (0, _utils.sanitizeHTML)(label)
            }
          });
        case "heading":
          // the case where there is HTML within the label
          return /*#__PURE__*/_react["default"].createElement("h2", {
            dangerouslySetInnerHTML: {
              __html: (0, _removeMarkdown["default"])(label)
            }
          });
        case "paragraph":
          return content ? /*#__PURE__*/_react["default"].createElement("div", {
            id: name || ''
          }, content) : /*#__PURE__*/_react["default"].createElement(_formElements.MarkdownHtml, {
            id: name || ""
          }, label);
        case "button":
          return /*#__PURE__*/_react["default"].createElement(_components.Button, {
            id: "t-".concat(_lodash["default"].snakeCase(fieldName)),
            name: fieldName,
            label: label,
            onClick: onClick,
            buttonStyle: buttonStyle,
            disabled: disabled
          });
        default:
          console.warn("Field type ".concat(intf, " \"").concat(label, "\" is not available"));
          return null;
      }
    }
  }]);
  return FieldStatic;
}(_react["default"].PureComponent);
FieldStatic.defaultProps = {
  onClick: function onClick() {},
  disabled: false
};
FieldStatic.propTypes = {
  "interface": (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.func, _propTypes.element]).isRequired,
  label: _propTypes.string,
  name: _propTypes.string,
  onClick: _propTypes.func,
  buttonStyle: _propTypes.string,
  disabled: _propTypes.bool
};
var _default = exports["default"] = FieldStatic;
var StaticFields = exports.StaticFields = ['markdown', 'scrollbox', 'scrollboxsmall', 'scrollboxlarge', 'label', 'heading', 'paragraph', 'button'];